import React from 'react';
import styled from 'styled-components';
import {
    Drawer as AntDrawer, Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SlideImage } from '../ProceedTopUp.style';
import { Slide } from "react-slideshow-image";

const Container = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100vh;
    max-width: 480px;
    z-index: ${props => props.open === 'true' ? 20 : -1};
`;

const Drawer = styled(AntDrawer)`
border-top-left-radius: 16px;
border-top-right-radius: 16px;
position: relative;

.ant-drawer-body {
    padding: 20px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;

    @media screen and (max-width: 360px) {
        padding: 16px 8px 8px 8px;
    }
}

.indicators {
    padding: 0 !important;
}

.react-slideshow-container+ul.indicators li,
.react-slideshow-container+ul.indicators .each-slideshow-indicator:before {
width: 16px;
height: 4px;
border-radius: 22px;
}

.react-slideshow-container+ul.indicators .each-slideshow-indicator:before {
background-color: #49028E;
}

.ant-btn-primary {
    height: 52px !important;
    margin-top: 20px;

    span {
        color: #fff;
        font-weight: 500;
    }
}
`;

const Text = styled.div`
padding-bottom: 24px;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #5D5189;
text-align: center;

@media screen and (max-width: 360px) {
    font-size: 13px;
}
`;

const SampleDrawer = ({
    active_topup_screenshot,
    receiving_account,
    open,
    handleClose,
}) => {
    const { t } = useTranslation();

    return (
        <Container open={open ? 'true' : 'false'}>
            <Drawer
                destroyOnClose
                size='large'
                autoFocus={false}
                closable={false}
                getContainer={false}
                placement='bottom'
                open={open}
                onClose={handleClose}
            >
                <Text>{!active_topup_screenshot && t("wallet.topupSampleDrawerSubTitle")}</Text>
                {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
                    (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0))
                    && (
                        <Slide
                            arrows={false}
                            autoplay={true}
                            indicators={true}
                            duration={3000}
                            transitionDuration={500}
                        >
                            {active_topup_screenshot
                                ? receiving_account?.payment_category_view_topup_images?.map(
                                    (image, key) => (
                                        <SlideImage key={key} src={image} />
                                    )
                                )
                                : receiving_account?.payment_category_view_sample_images?.map(
                                    (image, key) => (
                                        <SlideImage key={key} src={image} />
                                    )
                                )}
                        </Slide>
                    )}
                <Button
                    type='primary'
                    size='large'
                    onClick={handleClose}
                >
                    {t("common.ok")}
                </Button>
            </Drawer>
        </Container>
    )
}

export default SampleDrawer